const GrowthSection = () => {
    return (
        <section className="basic-area growth-area section-animate">
            <div className="container">
                <div className="basic-flex growth">
                    <img
                        className="basic-flex__image"
                        src="/images/activityDetails.gif"
                        alt="growth"
                    />

                    <div className="basic-flex__content">
                        <h2>Review your strengths and growth areas</h2>

                        <div>
                            You can also browse the questions that were asked
                            for each categories
                        </div>

                        <br></br>
                         <img
                            style={{
                                width: "600px", height: "300px", alignSelf: "center"
                            }}
                            className="basic-flex__image box-shadow"
                            src="/images/portal/response-view.png"
                            alt="activities"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GrowthSection;
